/**
 * Get all self-employed accounts with their product types
 * @param {Array} data - Array of products with accounts
 * @returns {Array} - Array of objects with account info and product type
 */
export const getSelfEmployedAccountsWithTypes = (data) => {
  if (!Array.isArray(data)) {
    return [];
  }

  const selfEmployedAccounts = [];

  data.forEach(product => {
    if (product.accounts && Array.isArray(product.accounts)) {
      product.accounts.forEach(account => {
        if (account.state === "עצמאי") {
          selfEmployedAccounts.push({
            accountNumber: account.accountNumber,
            state: account.state,
            stateId: account.stateId,
            employer: account.employer,
            balance: account.balance,
            seniority: account.seniority,
            productType: product.prodType,
            productName: product.name
          });
        }
      });
    }
  });

  return selfEmployedAccounts;
};

/**
 * Check if there's at least one self-employed account (legacy function for backward compatibility)
 * @param {Array} data - Array of products with accounts
 * @returns {boolean} - True if at least one account has state "עצמאי", false otherwise
 */
export const hasAtLeastOneSelfEmployedAccount = (data) => {
  const selfEmployedAccounts = getSelfEmployedAccountsWithTypes(data);
  return selfEmployedAccounts.length > 0;
};

/**
 * Process data and add hasSelfEmployed flag to each product
 * @param {Array} data - Array of products with accounts
 * @returns {Array} - Processed data with hasSelfEmployed flag
 */
export const processDataWithSelfEmployedFlag = (data) => {
  if (!Array.isArray(data)) {
    return [];
  }

  return data.map(product => {
    let hasSelfEmployed = false;
    
    if (product.accounts && Array.isArray(product.accounts)) {
      // Check if this product has at least one account with state "עצמאי"
      hasSelfEmployed = product.accounts.some(account => account.state === "עצמאי");
    }

    return {
      ...product,
      hasSelfEmployed
    };
  });
};

/**
 * Get all accounts with state "עצמאי" across all products
 * @param {Array} data - Array of products with accounts
 * @returns {Array} - Array of accounts with state "עצמאי"
 */
export const getSelfEmployedAccounts = (data) => {
  if (!Array.isArray(data)) {
    return [];
  }

  const selfEmployedAccounts = [];

  data.forEach(product => {
    if (product.accounts && Array.isArray(product.accounts)) {
      product.accounts.forEach(account => {
        if (account.state === "עצמאי") {
          selfEmployedAccounts.push({
            ...account,
            productName: product.name,
            productType: product.prodType
          });
        }
      });
    }
  });

  return selfEmployedAccounts;
}; 